(function () {
    'use strict';

    angular.module("imApp").factory("checkListsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1297,
                    parameters: parms || {}
                });
            },
            listChecks: function (parms) {
                return $ihttp.post({
                    method: 540,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
